import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import Home from '../pages/Home';
import About from '../pages/About';
import Products from '../pages/Products';
import Solutions from '../pages/Solutions';
import News from '../pages/News';
import NewsDetail from '../pages/News/NewsDetail';
import Contact from '../pages/Contact';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="products" element={<Products />} />
        <Route path="solutions" element={<Solutions />} />
        <Route path="news" element={<News />} />
        <Route path="news/:id" element={<NewsDetail />} />
        <Route path="contact" element={<Contact />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
